import updateCart from './updateCart';

// Guards against a duplicate save/navigation if the customer clicks checkout
// again (e.g. on a re-rendered link) while a save is already in flight.
let isNavigating = false;

// Persists the minicart order note to cart.note when the customer proceeds to
// checkout. The minicart checkout control is a link, not a form submit, so the
// note is saved via /cart/update.js immediately before navigation.
// A preserved value (in-progress text from a prior render) is restored so a
// quantity change mid-note doesn't discard what the customer typed.
const initMinicartOrderNote = (preservedNote) => {
  const note = document.querySelector('[data-minicart-content] [data-cart-order-note]');
  if (!note) return;

  const input = note.querySelector('[data-cart-order-note-input]');
  if (!input) return;

  if (preservedNote != null && preservedNote !== input.value) {
    input.value = preservedNote;
    if (preservedNote !== '') note.open = true;
  }

  const checkoutLink = document.querySelector('[data-minicart-content] [data-minicart-checkout]');
  if (!checkoutLink) return;

  checkoutLink.addEventListener('click', async (evt) => {
    // Let modifier/non-primary clicks (open in new tab, etc.) behave natively.
    if (evt.ctrlKey || evt.metaKey || evt.shiftKey || evt.altKey || evt.button !== 0) return;

    evt.preventDefault();
    if (isNavigating) return;
    isNavigating = true;

    const { href } = checkoutLink;
    // Never block checkout on a failed note save — navigate regardless.
    try {
      await updateCart({ note: input.value });
    } catch (err) {
      console.error('Failed to save order note:', err);
    }
    window.location.href = href;
  });
};

export default initMinicartOrderNote;
